import turnaroundStore from './store'

export default class TurnaroundModule {
  name = 'turnaround'
  constructor({ store }) {
    store.registerModule(this.name, turnaroundStore)
  }
}
